<template>
  <div class="">
    <nav class="num-container">
      <div class="num-entry">
          <div class="num-group">
            <router-link to="/">
            <img src="/static/icon-circle.svg" alt="" class="nav-circle">
            </router-link>
            <num-input :class="{numActive: checkActive(1)}" mode="1" ref="num1" v-model="slug1.num1" @isKey="isKey"></num-input>
            <num-input :class="{numActive: checkActive(2)}" mode="2" ref="num2" v-model="slug1.num2" @isKey="isKey"></num-input>
            <p class="point">.</p>
            <num-input :class="{numActive: checkActive(3)}" mode="3" ref="num3" v-model="slug2.num1" @isKey="isKey"></num-input>
            <num-input :class="{numActive: checkActive(4)}" mode="4" ref="num4" v-model="slug2.num2" @isKey="isKey"></num-input>
          </div>
          <div class="num-group">
            <p class="light" :class="{langActive: checkLang('en')}" @click="setLang('en')">En</p>
            <p class="light" :class="{langActive: checkLang('lv')}" @click="setLang('lv')">Lv</p>
            <p class="light" :class="{langActive: checkLang('ru')}" @click="setLang('ru')">Ru</p>
          </div>
      </div>
      <main class="num-keys" v-if="keyPadDown">
          <table class="num-keys-table" cellPadding="0" cellSpacing="0">
            <tr>
              <td><num-key value="1" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="2" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="3" @keyPushed="keyPushed"></num-key></td>
            </tr>
            <tr>
              <td><num-key value="4" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="5" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="6" @keyPushed="keyPushed"></num-key></td>
            </tr>
            <tr>
              <td><num-key value="7" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="8" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="9" @keyPushed="keyPushed"></num-key></td>
            </tr>
            <tr>
              <td colspan="2"><num-key value="0" @keyPushed="keyPushed"></num-key></td>
              <td><num-key value="<" @keyPushed="clearPushed"></num-key></td>
            </tr>
          </table>
      </main>
    </nav>
  </div>
</template>

<script>
  import {store} from '../store/store'
  import numInput from '../components/NumInput'
  import numKey from '../components/NumKey'
  export default {
    name: 'siteNav',
    components: {
      numInput:numInput,
      numKey:numKey
    },
    data() {
      return {
        vm:this,
        activeKey:0,
        keyPadDown:false,
        slug1: {
          num1:'_',
          num2:'_',
        },
        slug2: {
          num1:'_',
          num2:'_',
        }
      }
    },
    computed: {
      url() {
        return this.$store.getters.getDestUrl; 
      },
      gotoUrl() {
        return this.slug1.num1 + this.slug1.num2 + '/' + this.slug2.num1 + this.slug2.num2;
      },
      lang() { 
        return this.$store.state.langUrl;
      },
    },
    watch: {
      url(newVal) {
        let destUrl = this.$store.state.destUrl;
        let brokenArray = destUrl.split("");
        this.slug1.num1 = brokenArray[0];
        this.slug1.num2 = brokenArray[1];
        this.slug2.num1 = brokenArray[3];
        this.slug2.num2 = brokenArray[4];
        console.log(newVal);
      }
    },
    mounted() {
      
    },
    methods: {
      setLang(langSlug) {
          store.dispatch('setLangState', langSlug);
      },
      nextInput(val) {
        if (val != 'go') {
          val.$el.focus();
        } else {
          store.dispatch('setDestUrl', this.gotoUrl);
          this.$router.push('/' + this.gotoUrl);
        }
      },
      isKey(val) {
        this.activeKey = parseInt(val);
        this.keyPadDown = true;
      },
      checkActive(val) {
        if (val == this.activeKey) {
          return true;
        } else {
          return false;
        }
      },
      checkLang(val) {
        if (val == this.lang) {
          return true;
        } else {
          return false;
        }
      },
      clearPushed() {
        switch(this.activeKey) {
          case 1:
              this.slug1.num1 = 0;
              this.activeKey = 1;
              this.$refs.num1.$el.focus();
              break;
          case 2:
              this.slug1.num2 = 0;
              this.activeKey = 1;
              this.$refs.num1.$el.focus();
              break;
          case 3:
              this.slug2.num1 = 0;
              this.activeKey = 2;
              this.$refs.num2.$el.focus();
              break;
          case 4:
              this.slug2.num2 = 0;
              this.activeKey = 3;
              this.$refs.num3.$el.focus();
              break;
          default:
        }
      },
      keyPushed(val) {
          switch(this.activeKey) {
              case 1:
                  this.slug1.num1 = val;
                  this.$refs.num2.$el.focus();
                  this.activeKey = 2;
                  break;
              case 2:
                  this.slug1.num2 = val;
                  this.$refs.num3.$el.focus();
                  this.activeKey = 3;
                  break;
              case 3:
                  this.slug2.num1 = val;
                  this.$refs.num4.$el.focus();
                  this.activeKey = 4;
                  break;
              case 4:
                  this.slug2.num2 = val;
                  this.$refs.num4.$el.blur();
                  this.activeKey = 0;
                  store.dispatch('setDestUrl', this.gotoUrl);
                  store.dispatch('setDestChange', true);
                  this.$router.push('/' + this.gotoUrl);
                  this.keyPadDown = false;
                  break;
              default:
            }
      }   
    }
  }
</script>

<style lang="scss">
    .num-keys {
      position: absolute;
      width: 100%;
      height: 100vh;
      // background: #CCCCCC;
      background: rgb(190, 190, 190);
      .num-keys-table {
        width: 100%;
        margin: 0 auto;
    }
  }
  .numActive {
    // border-bottom: 1px solid red !important;
    color: red !important;
  }
  .num-keys-table {
    // margin: 1px;
    td {
      border: 1px solid #CCCCCC;
    }
  }
  .nav-circle {
    width:18px;
    height: 20px;
    line-height: 20px;
    margin-bottom:-4px;
    margin-right: 0.5rem;
    // border: 1px solid red;
    // width: 100px;
  }
  .numKey {
    padding: 2rem;
    margin: 0rem;
    border: none;
    // background: white;
    border-bottom: 2px solid white;
    color: black;
    appearance: none;
    outline: none;
    width: 100%;
    height: 8rem;
    font-size: 1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.6s ease-out;

  }
  .num-container {
    width: 100vw;
    background: white;
    color:black;
    position: fixed;
    border-bottom: 1px solid #CCC;
    top:0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    z-index: 100;
    will-change: transform;
    transform: translateZ(0);
    .num-entry {
      display: flex;
      align-items: center;
      justify-content: center;
      color: black;
      justify-content: space-between;
      padding: 0 2rem 1rem 2rem;
    }
    .num-group {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius:none;
      appearance: none;
      p {
        margin-left: 1rem;
        padding-bottom: 2px;
        border-bottom: 1px solid rgba(0,0,0,0);
      }
    }
  }
   .point {
      margin-left: 0.25rem !important;
      margin-right: 0.25rem !important;
    }
    .langActive {
      border-bottom: 1px solid black !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SiteNav.vue